var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#818CF8",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 9C15.3067 9 16.875 10.5683 16.875 12.5C16.875 14.4317 15.3067 16 13.375 16C11.4433 16 9.875 14.4317 9.875 12.5C9.875 10.5683 11.4433 9 13.375 9ZM12.1254 17.3125H14.6246C15.1879 17.3125 15.7293 17.4082 16.2324 17.5832C16.082 18.0508 16 18.5457 16 19.0625C16 20.6895 16.8066 22.1277 18.0453 23H8.06211C7.61367 23 7.25 22.6363 7.25 22.1879C7.25 19.4945 9.43203 17.3125 12.1254 17.3125ZM16.875 19.0625C16.875 16.8893 18.6393 15.125 20.8125 15.125C22.9857 15.125 24.75 16.8893 24.75 19.0625C24.75 21.2357 22.9857 23 20.8125 23C18.6393 23 16.875 21.2357 16.875 19.0625ZM20.8125 16.875C20.5719 16.875 20.375 17.0719 20.375 17.3125V19.0625C20.375 19.3031 20.5719 19.5 20.8125 19.5H22.125C22.3656 19.5 22.5625 19.3031 22.5625 19.0625Cnan nan 22.3656 18.625 22.125 18.625H21.25V17.3125C21.25 17.0719 21.0531 16.875 20.8125 16.875Z",
    fill: "#818CF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.463494de75c482c896ce0373b65d1613.svg";
export { ForwardRef as ReactComponent };